<template>
    <div class="user-card">
        <div class="user-title">Olá, seja bem vindo. Eu sou o seu corretor</div>

        <template v-if="status">
            <div class="name" v-if="user.name">{{ user.name }}</div>
            <div class="creci" v-if="user.creci">CRECI - {{ user.creci }}</div>
        </template>

        <template v-else>
            <div class="name">Facilita Corretor</div>
            <div class="creci">Facilitando o seu sonho.</div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            user: {
                type: Object,
                require: true,
                default() {
                    return {}
                },
            },
        },

        data() {
            return {}
        },

        computed: {
            status() {
                return this.user ? true : false
            },
        },
    }
</script>
